import { render, staticRenderFns } from "./LeftDrawer.vue?vue&type=template&id=eddc84b6&scoped=true"
import script from "./LeftDrawer.vue?vue&type=script&lang=ts"
export * from "./LeftDrawer.vue?vue&type=script&lang=ts"
import style0 from "./LeftDrawer.vue?vue&type=style&index=0&id=eddc84b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddc84b6",
  null
  
)

export default component.exports